<template>
	<inertia-head title="Affiliate Toolkit" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 v-if="user.is_super_sponsor==1" class="badge bg-warning text-white fs-lg">SUPER AFFILIATE</h1>
					<h1 class="fw-bold text-white mb-2">Affiliate Toolkit</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
					Looking to grow your affiliate side hustle? TRC Affiliate Toolkit is here to help! Our powerful, easy-to-use toolkit provides you with everything you need to get started with affiliate marketing – from referral links and training videos to help you maximize your profits.</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">

		<div v-if="is_show==1 && affiliateRes.affname_status!='Approved'" class="block mb-5">
			<div class="content pb-5">
				<div class="form-group h4 text-center">
					<p v-if="affiliateRes.affname==null" class="text-danger">
						<p class="text-danger">Please set your affiliate name</p>
					</p>
					<p v-if="affiliateRes.affname_status=='Pending'" class="text-warning">Please wait for the approval</p>
					<div v-if="affiliateRes.affname_status=='Declined'">
						<p  class="text-danger mb-1">DECLINED</p>
						<p class="fw-normal h6">{{affiliateRes.declined_remarks}}</p>
					</div>
					<p v-if="affiliateRes.affname_status=='Approved'" class="text-success">APPROVED</p>
				</div>
				<div class="row">
					<div class="col-md-9">
						<div class="form-group">
							<label>Affiliate Name</label>
							<input v-model="formAff.affname" type="text" name="affname" class="form-control"/>
						</div>
					</div>
					<div class="col-md-3">
						<div class="form-group">
							<div>&nbsp;</div>
							<button @click="updateAffiliateName()" type="button" class="btn btn-info">
								<span v-if="affiliateRes.affname==null">Update Affiliate Name</span>
								<span v-else>Change</span>
							</button>
						</div>
					</div>
				</div>
				<div class="mt-5">
					<p>Notes:</p>
					<p>
						<ul>
							<li>Only alphanumeric characters are accepted.</li>
							<li>Please keep your affiliate name decent.</li>
							<li>do not use misleading or deceptive words.</li>
							<li>No impersonation of other persons or other brands, please keep it original.</li>
							<li>Minimum of 8 and maximum of 20 characters.</li>
							<li>Please allow 1 business day for us to approve your affiliate name.</li>
						</ul>
					</p>
				</div>
			</div>
		</div>
		
		<div v-if="$page.props.user.gr_exclusive_aff==0" class="block block-rounded mt-5">
			<div class="block-content block-content-full text-center">
				<p>Click the button below to subscribe and get access to exclusive affiliate materials like webinars, best practices, and updates.</p>
				<button type="button" @click="confirmJoinExclusiveAff()" class="btn btn-info">
					Join the exclusive TRC Affiliate list
				</button>
			</div>
		</div>

		<div class="block block-rounded mt-5">
			<div class="block-content block-content-full">
				<div class="row">
					<div class="col-xl-6 mb-5">
						<h5 class="border-bottom pb-2">Pages</h5>
						<table class="table table-borderless border border-secondary shadow fs-sm">
							<tbody>
								<tr v-for="(page) in aff_links" :key="page">
									<td width="1%">
										<i class="fa fa-eye"></i>
										<div class="mt-2">
											<span class="badge badge-fill bg-danger">{{page.total_clicks}}</span>
										</div>
									</td>
									<td>
										<div class="form-material">
											<label class="form-label text-muted" :for="page.name">{{ page.description }}</label>
											<input type="text" :id="'page_'+page.counter" :name="'page_'+page.counter" class="form-control fs-sm" :value="page.web_link+(affname != null ? (is_show==1 ? (affiliateRes.affname_status=='Approved' ? affname : mid) : mid) : mid)">
										</div>
									</td>
									<td width="10%" class="text-end align-bottom">
										<button @click="copyPageLink(page.counter)" class="btn btn-secondary btn-sm">Copy</button>
									</td>
								</tr>
							</tbody>
						</table>
						<div class="text-center mt-4">
							<inertia-link :href="'/member/affiliate-program/agreement-and-policies'" class="btn btn-info btn-sm">Please make sure to follow our Affiliate Agreement</inertia-link>

							<div v-if="$page.props.user.gr_exclusive_aff==1" class="text-center mt-3">
								You are currently subscribed to the TRC Affiliate email list.
							</div>
						</div>
					</div>
					<div class="col-xl-6">
						<h5 class="border-bottom pb-2">Your Click Summary</h5>
						<div class="form">
							<label class="form-label">Date</label>
							<div class="input-group">
							<input
								v-model="this_month"
								type="date"
								class="form-control fs-sm form-control-sm"
								placeholder="Search here..."
							/>
							<button @click="displayClickSummary()" type="button" class="input-group-btn btn btn-info">Display</button>
							</div>
						</div>
						<vue-chart-dynamic :width="500" :height="420" ref="dataList"/>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-xl-4">
				<div class="block block-rounded">
					<div class="block-content">
						<h5 class="border-bottom pb-2">TKT Event Coupon Code</h5>
						<div v-if="is_show==1">
							<p v-if="affname!==null && affiliateRes.affname_status=='Approved'" class="h2 text-center text-danger">{{affname}}</p>
							<p v-else class="h2 text-center text-danger">TRC{{mid}}AFF</p>
						</div>
						<div v-else>
							<p class="h2 text-center text-danger">TRC{{mid}}AFF</p>
						</div>
						<div class="fs-sm">
							<p>This coupon code will give you the following:</p>
							<ol>
								<li>10% Discount on total ticket purchase for the coupon user.</li>
								<li>20% Affiliate Commission of net ticket purchase.</li>
								<li>Auto-tagging on member checkout as long as the coupon user registers with the same email.</li>
							</ol>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xl-8">
				<div class="block block-rounded">
					<div class="block-content">
						<div class="row">
							<div class="col-xl-6 mb-5">
								<h5 class="border-bottom pb-2">Available Events</h5>
								<div v-for="(event,eindex) in tktphEvents.available_events" class="me-3">
									<a :href="'https://tkt.ph/event/'+event.event_uuid+'?trc_member='+member_info" target="_blank" class="text-black fs-sm block">
										<p class="fw-bold mb-1">{{event.event_title}}</p>	
										<span>{{event.event_dates}} at {{event.time_start}}</span>
										<p class="text-muted">(TKT-{{event.event_uuid}}-{{(event.date_start).replace("-","")}})</p>
									</a>
								</div>
							</div>
							<div class="col-xl-6">
								<h5 class="border-bottom pb-2">Past Events</h5>
								<div v-for="(event,eindex) in tktphEvents.past_events">
									<a v-if="(event.event_title).toLowerCase().lastIndexOf('test')<0" :href="'https://tkt.ph/event/'+event.event_uuid" target="_blank" class="text-black fs-sm block">
										<p class="fw-bold mb-1">{{event.event_title}}</p>	
										<span>{{event.event_dates}} at {{event.time_start}}</span>
										<p class="text-muted">(TKT-{{event.event_uuid}}-{{(event.date_start).replace("-","")}})</p>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="row mt-3">
			<div class="block block-rounded">
				<div class="block-header border-bottom">
					<h4 class="h4 m-0"><i class="fa fa-video"></i> MARKETING VIDEOS</h4>
				</div>
				<div class="block-content block-content-full">
					<div class="row">
						<div v-for="mvideo in marketingVideos" class="col-lg-6 mb-4 pb-3">
							<div class="text-center p-3 border shadow">
								<div style="padding: 56.25% 0 0 0; position: relative">
									<iframe
										:src="'https://player.vimeo.com/video/'+mvideo.video_id"
										style="
											position: absolute;
											top: 0;
											left: 0;
											width: 100%;
											height: 100%;
										"
										frameborder="0"
										allow="autoplay; fullscreen; picture-in-picture"
										allowfullscreen
									></iframe>
								</div>
								<p class="mt-3 mb-3">{{mvideo.title}}</p>
								<a :href="mvideo.download_link" class="btn btn-primary btn-sm" target="_blank"><i class="fa fa-download"></i> Download</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row mt-3">
			<div class="block block-rounded">
				<div class="block-header border-bottom">
					<h4 class="h4 m-0"><i class="fa fa-image"></i> MARKETING IMAGES</h4>
				</div>
				<div class="block-content block-content-full">
					<div class="row">
						<div v-for="mimage in marketingImages" class="col-lg-4 mb-4 pb-3">
							<div class="text-center p-3 border shadow">
								<img :src="mimage.image_url" :alt="mimage.title" class="img-fluid">
								<p class="mt-3 mb-3 fw-bold">{{mimage.title}}</p>
								<a
									v-if="mimage.image_url"
									:href="'/member/download/affiliate-program/image/' + mimage.image_name" target="_blank"
									class="btn btn-primary btn-sm"
								>
									<i class="fa fa-cloud-download-alt me-1"></i>
									Download
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row mt-3">
			<div class="block block-rounded">
				<div class="block-header border-bottom">
					<h4 class="h4 m-0"><i class="fa fa-envelope"></i> EMAIL SWIPES</h4>
				</div>
				<div class="block-content block-content-full">
					<div class="row">
						<div v-for="(mailswipe,m_index) in emailSwipes" class="col-lg-4 mb-4 pb-3">
							<div class="text-center p-3 border shadow ribbon ribbon-left ribbon-bookmark ribbon-info">
								<div class="ribbon-box">
			                    	<i class="fa fa-fw fa-envelope"></i>
			                  	</div>
								<div>
									<p class="mt-3 mb-3 fw-bold h4">{{mailswipe.title}}</p>
									<button @click="selectEmailSwipe(m_index)" type="button" class="btn btn-primary btn-sm"><i class="fa fa-search"></i> View Format</button>
								</div>
							</div>
						</div>
					</div>
					<div v-if="emailSwipes.length<=0" class="row">
						<div class="col-lg-12">
							<p class="text-center m-0 h5 text-danger">No Available Email Format</p>
						</div>
					</div>
				</div>
			</div>

			
			<email-swipe-modal ref="ESModal" :emailSwipe="selectedEmailSwipe"/>


			<modal ref="AffExConfirmModal" size="modal-md">
				<template #title>Confirmation</template>
				<template #body>
					<div class="mb-5 text-bold text-center">
						You're about to join our exclusive affiliate list, where you'll receive exciting updates and opportunities as a TRC Affiliate!
					</div>
				</template>
				<template #footer>
					<button @click="joinExclusiveAff()" type="button" :disabled="formJoinAff.processing" class="btn btn-alt-success">
						<div
							v-if="formJoinAff.processing"
							class="spinner-border spinner-border-sm text-dark me-1"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						Yes, add me now
					</button>
				</template>
			</modal>


		</div>
	</div>
</template>

<script>
import { onMounted, ref, reactive, watch } from 'vue';
import AuthLayout from '../../../Layouts/AuthLayout';
import { Inertia } from '@inertiajs/inertia';
import { useForm } from '@inertiajs/inertia-vue3';
import { createToaster } from '@meforma/vue-toaster';
import EmailSwipeModal from '../../../Shared/Components/Modals/EmailSwipeModal';
import VueChartDynamic from '../../../Shared/Components/VueChartDynamic';

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: AuthLayout,
	props: {
		app 			: Object,
		is_show			: Number,
		user			: Object,
		affiliateRes 	: Object,
		errors			: Object,
		api_response	: Object,
		affname 		: String,
		mid 			: Number,
		member_info 	: String,
		aff_links		: Object,
		clicks_summary	: Object,
		tktphEvents		: Object,
		trainingsVideos : Object,
		marketingVideos : Object,
		marketingImages : Object,
		emailSwipes		: Array
	},
	components:{ VueChartDynamic, EmailSwipeModal },
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const toast = createToaster();

		const formAff = useForm({
			affname 		: props.affiliateRes.affname,
			prev_affname 	: props.affiliateRes.prev_affname
		});

		const formJoinAff = useForm({});

		const ESModal 				= ref();
		const AffExConfirmModal 	= ref();
		const selectedEmailSwipe 	= reactive({
										id 				: '',
										title 			: '',
										email_format 	: ''
									});

		const this_month 			= ref();

		// const chart_data 	= ref(props.clicks_summary);
		
		const dataList 		= ref();

		const updateAffiliateName = ()=>{

			if([null,''].includes(formAff.affname))
			{
	            toast.show("Please enter your affiliate name.", { type: "error"})
	            return false;
			}else if(['blank','blanked'].includes(formAff.affname.toLowerCase()))
            {
                toast.show("Please enter your affiliate name or blank is not allowed.", { type: "error"})
                return false;
            }

            formAff.prev_affname = props.affiliateRes.prev_affname;

            formAff.post(route("member.affiliate-program.post.affname-update"),{
				preserveState: true,
				preserveScroll: true,
				only:['affname,affiliateRes,errors,api_response'],
				onSuccess: (res)=>{
					if(props.api_response!==null)
					{
						if(props.api_response.result=="success")
						{
							toast.show("Affiliate name was successfully submitted", { type: props.api_response.result});
						}else if(props.api_response.result=="exist")
						{
							toast.show("Affiliate name was already used", { type: "error"});
						}else
						{
							toast.show("Failed to submit the affiliate name", { type: "error"});
						}
					}
				},
				onError: (errors)=>{
					
					if(errors.affname!=null && errors.affname!='')
					{
						toast.show(errors.affname, { type: "error"});
					}
				}
			});

		}

		const confirmJoinExclusiveAff = ()=>{
			AffExConfirmModal.value.toggleModal();
		}

		const joinExclusiveAff =()=>{

			formJoinAff.post(route("member.affiliate-program.post.gr-join-exclusive"),{
				preserveState: true,
				preserveScroll: true,
				only:['user,api_response'],
				onSuccess: ()=>{
					if(props.api_response!==null)
					{
						if(props.api_response.result=="success")
						{
							AffExConfirmModal.value.toggleModal();
							toast.show("Thank you for joining the TRC Affiliate Exclusive list! You'll soon start receiving emails at "+props.user.email+" with exciting updates and information about our affiliate system.", { type: "success"});
						}else
						{
							toast.show("Failed to join, please try again.", { type: "error"});
						}
					}
				}
			});

		}

		const copyPageLink 	= (page_id)=>{
								var copy_link = document.getElementById('page_'+page_id);
								copy_link.select();
								document.execCommand('copy');
								toast.show(copy_link.value+' copied', { type: 'success'})
							};


		const displayClickSummary = ()=>{
										Inertia.get(
											'/member/affiliate-program/toolkit', {this_month:this_month.value},
											{
												// replace: true,
												preserveState: true,
												preserveScroll: true,
												only: ['clicks_summary']
											}
										)
									}

		const selectEmailSwipe = (swipe_id)=>{
			var selected = props.emailSwipes[swipe_id];

			selectedEmailSwipe.id 			= selected.id;
			selectedEmailSwipe.title 		= selected.title;
			selectedEmailSwipe.email_format = selected.email_format;

			ESModal.value.toggleModal();
		}

		watch(()=>props.clicks_summary,(new_data,old_data)=>{
			dataList.value?.getData(new_data);
		});


		return {
			formAff,
			formJoinAff,
			updateAffiliateName,
			joinExclusiveAff,
			ESModal,
			AffExConfirmModal,
			confirmJoinExclusiveAff,
			selectEmailSwipe,
			selectedEmailSwipe,
			this_month,
			dataList,
			copyPageLink,
			displayClickSummary
		}
	},
}
</script>
